import DOMPurify from 'isomorphic-dompurify';
import { createElement } from 'react';
import { dompurifyConfig } from './dompurifyConfig';

const SafeHtmlRenderer = ({ tag, content, attributes = {}, children, className, ...rest }) => {
  const isStringContent = typeof content === 'string';

  const sanitizedHTML = isStringContent ? DOMPurify.sanitize(content, { ...dompurifyConfig, ...attributes }) : '';

  const props = {
    className,
    ...(isStringContent ? { dangerouslySetInnerHTML: { __html: sanitizedHTML } } : { children }),
    ...rest,
  };

  return createElement(tag, props);
};

export { SafeHtmlRenderer };
